<template>
    <div class="testing-components">
        <h1>Testing Components</h1>
        <p style="margin-bottom: 50px;">This is a test component.</p>
        <Stepper :steps="steps" :activeStep="currentStep" :setCurrentStep="setCurrentStep" :maxStep="maxStep"></Stepper>
        <TournamentProfileCard />
        <TournamentAwardsCard />
        <Table />
    </div>
</template>

<script>
import Table from './components/tournament-pos-table/Table.vue';
import TournamentAwardsCard from './components/TournamentAwardsCard.vue';
import TournamentProfileCard from './components/TournamentProfileCard.vue';
import Stepper from './views/Funding/Simulation/components/Wizard/Stepper.vue';
export default {
    name: 'TestingComponents',
    components: {
        TournamentProfileCard,
        TournamentAwardsCard,
        Table,
        Stepper
    },
    data: function(){
        return {
            currentStep: 1,
            steps: 4,
            nxtBtnDisabled: true,
            maxStep: 1,
        }
    },
    methods: {
        setCurrentStep(step) {
            this.currentStep = step;
        },
    }
};
</script>

<style scoped>
.testing-components {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #F8F8F8;
}
h1 {
    color: #42b983;
}
</style>